import React from 'react';

interface ComparisonBarProps {
  agenda: number;
  walkIn: number;
  agendaPercentage: number;
  walkInPercentage: number;
}

export const ComparisonBar: React.FC<ComparisonBarProps> = ({
  agenda,
  walkIn,
  agendaPercentage,
  walkInPercentage,
}) => {
  return (
    <div className='relative w-full h-24 bg-slate-50 rounded-2xl overflow-hidden border-2 border-slate-100 flex shadow-inner group'>
      <div
        className='h-full bg-indigo-500 relative transition-all duration-1000 ease-out group-hover:opacity-90 min-w-[20px]'
        style={{ width: `${Math.max(agendaPercentage, 1)}%` }}
      >
        <div className='absolute top-0 right-0 h-full w-[2px] bg-white opacity-20' />
        <div className='absolute -top-7 left-0 text-[10px] font-black text-indigo-600 uppercase tracking-tight whitespace-nowrap animate-in slide-in-from-left duration-700'>
          {agenda} Agendados
        </div>
      </div>
      <div
        className='h-full bg-amber-500 relative transition-all duration-1000 ease-out group-hover:opacity-90 flex-1'
        style={{ width: `${walkInPercentage}%` }}
      >
        <div className='absolute -top-7 right-0 text-[10px] font-black text-amber-600 uppercase tracking-tight whitespace-nowrap animate-in slide-in-from-right duration-700'>
          {walkIn} Espontáneos
        </div>
      </div>
    </div>
  );
};
